import useNavigator from "@saleor/hooks/useNavigator";
import useNotifier from "@saleor/hooks/useNotifier";
import useShop from "@saleor/hooks/useShop";
import { commonMessages } from "@saleor/intl";
import { stringify as stringifyQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";

import { maybe } from "../../misc";
import {
  CornerMarkTranslationInput,
  LanguageCodeEnum
} from "../../types/globalTypes";
import TranslationsCornerMarkPage, {
  fieldNames
} from "../components/TranslationsCornerMarkPage";
import { TypedUpdateCornerMarkTranslations } from "../mutations";
import { TypedCornerMarkTranslationDetails } from "../queries";
import { UpdateCornerMarkTranslations } from "../types/UpdateCornerMarkTranslations";
import {
  // languageEntitiesUrl,
  languageEntityUrl,
  TranslatableEntities
} from "../urls";

export interface TranslationsCornerMarkQueryParams {
  activeField: string;
}
export interface TranslationsCornerMarkProps {
  id: string;
  languageCode: LanguageCodeEnum;
  params: TranslationsCornerMarkQueryParams;
}

const TranslationsCornerMark: React.FC<TranslationsCornerMarkProps> = ({
  id,
  languageCode,
  params
}) => {
  const navigate = useNavigator();
  const notify = useNotifier();
  const shop = useShop();
  const intl = useIntl();

  const onEdit = (field: string) =>
    navigate(
      "?" +
        stringifyQs({
          activeField: field
        }),
      true
    );
  const onUpdate = (data: UpdateCornerMarkTranslations) => {
    if (data.cornerMarkTranslate.errors.length === 0) {
      notify({
        status: "success",
        text: intl.formatMessage(commonMessages.savedChanges)
      });
      navigate("?", true);
    }
  };
  const onDiscard = () => {
    navigate("?", true);
  };

  return (
    <TypedCornerMarkTranslationDetails
      variables={{ id, language: languageCode }}
    >
      {pageHeaderTranslations => (
        <TypedUpdateCornerMarkTranslations onCompleted={onUpdate}>
          {(updateTranslations, updateTranslationsOpts) => {
            const handleSubmit = (field: string, data: string) => {
              const input: CornerMarkTranslationInput = {};
              if (field === fieldNames.title) {
                input.title = data;
              }
              updateTranslations({
                variables: {
                  id,
                  input,
                  language: languageCode
                }
              });
            };

            return (
              <TranslationsCornerMarkPage
                activeField={params.activeField}
                disabled={
                  pageHeaderTranslations.loading ||
                  updateTranslationsOpts.loading
                }
                languageCode={languageCode}
                languages={maybe(() => shop.languages, [])}
                saveButtonState={updateTranslationsOpts.status}
                onBack={() => history.go(-1)}
                onEdit={onEdit}
                onDiscard={onDiscard}
                onLanguageChange={lang =>
                  navigate(
                    languageEntityUrl(lang, TranslatableEntities.cornerMark, id)
                  )
                }
                onSubmit={handleSubmit}
                cornerMark={maybe(() => pageHeaderTranslations.data.cornerMark)}
              />
            );
          }}
        </TypedUpdateCornerMarkTranslations>
      )}
    </TypedCornerMarkTranslationDetails>
  );
};
TranslationsCornerMark.displayName = "TranslationsCornerMark";
export default TranslationsCornerMark;
